
export const AppSettings = {
  APP_ID: 'SBAV',
  APP_NAME: 'SISTEMA DE BONO DE ARRENDAMIENTO PARA VIVIENDAS',
  APP_TITLE: 'SBAV | Bono de Arrendamiento para Viviendas',
  APP_COPYRIGHT: 'FMV &copy; 2019'
};
